export enum FileStorageTypes
 {
  FormTemplate = 1,
  FormTemplateAnswer = 2,
  FormAnswerTypeAttachment = 3,
  FormAttachment = 4,
  SurveyReport = 5,
  SurveyFlatReport = 6,
  GRCReport = 7,
  CommerceReport = 8,
  ThirdPartyImport = 9,
  SurveyLaunchRecipientsImport = 10,
  FileImported = 11,
  DueDiligenceRequestAnswerFiles = 12,
  DueDiligenceRequestFiles = 13,
  FileTags = 14,
  FollowUpSubTaskFile = 15,
  ThirdPartyFollowUpTaskFormFiles = 16,
  ThirdPartyFollowUpTaskFormItemFiles = 17,
  UserManuals = 18,
  RequestEvaluationReports = 19,
  RequestFollowUpPlanReports = 20,
  ThirdPartyEvaluationFollowUpTaskFiles = 21,
  ThirdPartyEvaluationFormAnswerFiles = 22,
  FollowUpTaskFormFiles = 23,
  FollowUpTaskFormVideoFiles = 24,
  }